(function () {
  var deck = document.querySelector('.pm [data-pm-deck]');
  if (!deck || deck.dataset.pmBound) return;
  deck.dataset.pmBound = '1';

  var slides = deck.querySelectorAll('[data-pm-slide]');
  var thumbs = deck.querySelectorAll('[data-pm-dot]');
  var track = deck.querySelector('[data-pm-track]');
  var live = deck.querySelector('[data-pm-live]');
  var current = deck.querySelector('[data-pm-current]');
  var progress = deck.querySelector('[data-pm-progress]');
  var strip = deck.querySelector('.pm-thumbs');
  var expandBtn = deck.querySelector('[data-pm-expand]');
  var expandLabel = deck.querySelector('[data-pm-expand-label]');
  var n = slides.length, cur = 0;
  if (!n) return;

  function warm(k) {
    var im = slides[(k + n) % n].querySelector('img');
    if (im && im.loading === 'lazy') im.loading = 'eager';
  }

  function go(i, announce) {
    cur = (i + n) % n;
    track.style.transform = 'translateX(' + (-100 * cur) + '%)';
    slides.forEach(function (s, k) {
      var on = k === cur;
      s.classList.toggle('is-active', on);
      if (on) { s.removeAttribute('aria-hidden'); s.removeAttribute('inert'); }
      else { s.setAttribute('aria-hidden', 'true'); s.setAttribute('inert', ''); }
    });
    thumbs.forEach(function (d, k) {
      d.classList.toggle('is-active', k === cur);
      if (k === cur) d.setAttribute('aria-current', 'step'); else d.removeAttribute('aria-current');
    });
    warm(cur); warm(cur + 1); warm(cur - 1);
    if (current) current.textContent = cur + 1;
    if (progress) progress.style.width = ((cur + 1) / n * 100) + '%';
    var t = thumbs[cur];
    if (strip && t) strip.scrollTo({ left: t.offsetLeft - (strip.clientWidth - t.offsetWidth) / 2, behavior: 'smooth' });
    if (announce && live) live.textContent = slides[cur].getAttribute('aria-label');
  }

  /* Expand: real full screen where supported, otherwise a fixed overlay */
  var native = !!(deck.requestFullscreen || deck.webkitRequestFullscreen);
  function isExpanded() { return deck.classList.contains('is-expanded'); }
  function setState(on) {
    deck.classList.toggle('is-expanded', on);
    document.documentElement.classList.toggle('pm-lock', on);
    expandBtn.setAttribute('aria-pressed', on ? 'true' : 'false');
    expandLabel.textContent = on ? 'Close' : 'Full screen';
    if (on) deck.focus({ preventScroll: true });
  }
  function open() {
    setState(true);
    if (native) {
      try {
        var p = deck.requestFullscreen ? deck.requestFullscreen() : deck.webkitRequestFullscreen();
        if (p && p.catch) p.catch(function () {});
      } catch (e) {}
    }
  }
  function close() {
    var fs = document.fullscreenElement || document.webkitFullscreenElement;
    if (fs === deck) {
      if (document.exitFullscreen) document.exitFullscreen().catch(function () {});
      else if (document.webkitExitFullscreen) document.webkitExitFullscreen();
    }
    setState(false);
    expandBtn.focus({ preventScroll: true });
  }
  var wasFs = false;
  function onFs() {
    var fs = document.fullscreenElement || document.webkitFullscreenElement;
    if (fs === deck) wasFs = true;
    else if (wasFs) { wasFs = false; if (isExpanded()) setState(false); }
  }
  document.addEventListener('fullscreenchange', onFs);
  document.addEventListener('webkitfullscreenchange', onFs);

  expandBtn.addEventListener('click', function () { isExpanded() ? close() : open(); });
  deck.querySelectorAll('[data-pm-zoom]').forEach(function (z) {
    z.addEventListener('click', function () { if (!isExpanded()) open(); });
  });

  deck.querySelector('[data-pm-prev]').addEventListener('click', function () { go(cur - 1, true); });
  deck.querySelector('[data-pm-next]').addEventListener('click', function () { go(cur + 1, true); });
  thumbs.forEach(function (d) { d.addEventListener('click', function () { go(parseInt(d.getAttribute('data-pm-dot'), 10), true); }); });

  deck.addEventListener('keydown', function (e) {
    if (e.key === 'ArrowRight') { go(cur + 1, true); e.preventDefault(); }
    else if (e.key === 'ArrowLeft') { go(cur - 1, true); e.preventDefault(); }
    else if (e.key === 'Escape' && isExpanded()) { close(); e.preventDefault(); }
  });

  var x0 = null, y0 = null;
  track.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; y0 = e.touches[0].clientY; }, { passive: true });
  track.addEventListener('touchend', function (e) {
    if (x0 === null) return;
    var dx = e.changedTouches[0].clientX - x0, dy = e.changedTouches[0].clientY - y0;
    if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy)) go(cur + (dx < 0 ? 1 : -1), true);
    x0 = null;
  }, { passive: true });

  go(0, false);
})();